import WarehouseOutlined from '@mui/icons-material/WarehouseOutlined';
import Container from '@mui/material/Container';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import WarehousesSection from '@/sections/warehouses/warehouses-section';

const WarehousesPage = () => {
  usePageTitle('Fulfill99 - Almacenes');

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Almacenes" mt={5}>
        <WarehouseOutlined fontSize="large" />
      </SectionTitle>
      <WarehousesSection />
    </Container>
  );
};

export default WarehousesPage;
